/**
 * Filter Configuration for Mega-Menu Collection Pages
 * This file defines the sidebar filters for each category
 */

// Use a self-executing check to prevent redeclaration errors
if (typeof window.FILTER_CONFIG === "undefined") {
  window.FILTER_CONFIG = {
    // Calcinha filters
    calcinha: {
      title: "Calcinhas",
      showCollections: true,
      categoria: [
        { label: "Fio Dental", tag: "fio-dental" },
        { label: "Biquíni", tag: "biquini" },
        { label: "Tanga", tag: "calcinha-tanga" },
        { label: "String", tag: "calcinha-string" },
        { label: "Absorvente", tag: "absorvente" },
        { label: "Caleçon", tag: "calcinha-calecon" },
        { label: "Calça Boneca", tag: "calcinha-boneca" },
      ],
      caracteristicas: [
        { label: "Laterais Finas", tag: "cava-baixa" },
        { label: "Laterais Médias", tag: "cava-media" },
        { label: "Laterais Largas", tag: "cava-alta" },
        { label: "Alta Compressão", tag: "alta-compressao" },
        { label: "Média Compressão", tag: "media-compressao" },
        { label: "Sem Costura", tag: "sem-costura" },
        { label: "Cintura Alta", tag: "cintura-alta" },
      ],
      tecido: [
        { label: "100% Algodão", tag: "100-algodao" },
        { label: "Cotton", tag: "cotton" },
        { label: "Microfibra", tag: "microfibra" },
        { label: "Renda", tag: "renda" },
        { label: "Modal", tag: "modal" },
      ],
    },

    // Sutiã filters
    sutia: {
      title: "Sutiãs",
      showCollections: true,
      categoria: [
        { label: "Básicos", tag: "sutia-basico" },
        { label: "Sustentação", tag: "sustentacao" },
        { label: "Amamentação", tag: "amamentacao" },
        { label: "Cirúrgico/Mastecto", tag: "mastectomia" },
        { label: "Renda", tag: "renda" },
        { label: "Plus Size", tag: "plus-size" },
      ],
      caracteristicas: [
        { label: "Com Bojo", tag: "com-bojo" },
        { label: "Sem Bojo", tag: "sem-bojo" },
        { label: "Nadador", tag: "sutia-nadador" },
        { label: "Tomara que Caia", tag: "tomara-que-caia" },
        { label: "Meia Taça", tag: "meia-taca" },
        { label: "Com Aro", tag: "com-arco" },
      ],
      tecido: [
        { label: "Microfibra", tag: "microfibra" },
        { label: "Cotton", tag: "cotton" },
        { label: "Renda", tag: "renda" },
        { label: "Power Jersey", tag: "power" },
      ],
    },

    // Infantil filters
    infantil: {
      title: "Infantil",
      categoria: [
        { label: "Calcinhas", tag: "calcinha" },
        { label: "Top/Sutiã", tag: "sutia" },
      ],
      caracteristicas: [
        { label: "Com Viés", tag: "com-vies" },
        { label: "Com Elástico", tag: "com-elastico" },
      ],
      tecido: [
        { label: "100% Algodão", tag: "100-algodao" },
        { label: "Cotton", tag: "cotton" },
      ],
    },

    // Cintas e Modeladores filters
    "cintas-e-modeladores": {
      title: "Cintas e Modeladores",
      categoria: [
        { label: "Cintas", tag: "cinta" },
        { label: "Modeladores", tag: "modelador" },
        { label: "Faixas", tag: "faixa" },
        { label: "Bermudas", tag: "bermuda" },
      ],
      caracteristicas: [
        { label: "Alta Compressão", tag: "alta-compressao" },
        { label: "Média Compressão", tag: "media-compressao" },
        { label: "Com Barbatanas", tag: "com-barbatanas" },
        { label: "Abertura Frontal", tag: "abertura-frontal" },
        { label: "Com Zíper", tag: "com-ziper" },
        { label: "Reforço Frontal", tag: "reforco-frontal" },
      ],
      tecido: [
        { label: "Setinete", tag: "setinete" },
        { label: "Power Jersey", tag: "power" },
        { label: "Body Tex", tag: "body-tex" },
      ],
    },

    // Maternidade filters
    maternidade: {
      title: "Maternidade",
      categoria: [
        { label: "Gestante / Pré Parto", tag: "gestante" },
        { label: "Pós Parto", tag: "pos-parto" },
        { label: "Amamentação", tag: "amamentacao" },
      ],
      caracteristicas: [
        { label: "Com Bojo", tag: "com-bojo" },
        { label: "Sem Bojo", tag: "sem-bojo" },
        { label: "Abertura Frontal", tag: "abertura-frontal" },
        { label: "Frente Dupla", tag: "frente-dupla" },
      ],
      tecido: [
        { label: "Microfibra", tag: "microfibra" },
        { label: "Cotton", tag: "cotton" },
        { label: "Power Jersey", tag: "power" },
        { label: "Modal", tag: "modal" },
      ],
    },

    // Estética/Cirúrgica filters
    "estetica-cirurgica": {
      title: "Estética e Cirúrgica",
      categoria: [
        { label: "Cintas Pós Cirúrgicas", tag: "cinta" },
        { label: "Modeladores Pós Cirúrgicos", tag: "modelador" },
        { label: "Sutiãs Pós Cirúrgicos", tag: "sutia" },
        { label: "Faixas Pós Cirúrgicas", tag: "faixa" },
        { label: "Mastectomia", tag: "mastectomia" },
        { label: "Prótese", tag: "protese" },
      ],
      caracteristicas: [
        { label: "Alta Compressão", tag: "alta-compressao" },
        { label: "Média Compressão", tag: "media-compressao" },
        { label: "Abertura Frontal", tag: "abertura-frontal" },
        { label: "Com Zíper", tag: "com-ziper" },
        { label: "Sem Costura", tag: "sem-costura" },
      ],
      tecido: [
        { label: "Setinete", tag: "setinete" },
        { label: "Power Jersey", tag: "power" },
      ],
    },
  };
}
